import React from 'react'
import logger from './utils/logger';
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx'
import { AuthProvider } from './auth/AuthProvider';
import { RBACProvider } from './auth/RBACProvider';

logger.debug('main.tsx loaded');
logger.debug('React version:', React.version);

const root = document.getElementById('root');
logger.debug('Root element:', root);

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <RBACProvider>
            <App />
          </RBACProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
  logger.debug('App rendered');
} else {
  logger.error('Root element not found!');
}
